import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventComponent } from "./event/event.component";
import { ProcessComponent} from "./process/process.component";
import {ServiceComponent} from "./service/service.component";
import { TeamComponent } from './team/team.component';
import { ContactComponent } from './contact/contact.component';


const routes: Routes = [


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
